import { PartnerNameUrlEnum } from '@types';
export const getInstructionUrl = (partner, isChild) => {
    const url = `/instruction/${PartnerNameUrlEnum[partner]}`;
    return isChild ? `/child${url}` : url;
};
